import React from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'

import RadioGroupProvider from 'providers/RadioGroupProvider'

import { makeStyles } from '@material-ui/core'

import styles from './styles'

const useStyles = makeStyles(styles)

const RadioCardGroup = ({
  name,
  value,
  className,
  onChange,
  onChangeData,
  children,
}) => {
  const classes = useStyles()

  return (
    <RadioGroupProvider
      name={name}
      value={value}
      onChange={onChange}
      onChangeData={onChangeData}
    >
      <div className={clsx(classes.root, className)}>{children}</div>
    </RadioGroupProvider>
  )
}

RadioCardGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  name: PropTypes.string,
  value: PropTypes.any,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onChangeData: PropTypes.func,
}

export default RadioCardGroup
